export default ({ width = 14, height = 14 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.04716 19.9247C4.50759 20.1887 3.89533 19.726 4.00436 19.1353L5.16457 12.8287L0.239945 8.354C-0.219947 7.93533 0.0190863 7.17 0.635537 7.08733L7.48221 6.15933L10.5351 0.39C10.8105 -0.13 11.5555 -0.13 11.8309 0.39L14.8838 6.15933L21.7305 7.08733C22.3469 7.17 22.586 7.93533 22.1247 8.354L17.2014 12.8287L18.3617 19.1353C18.4707 19.726 17.8584 20.1887 17.3189 19.9247L11.1809 16.9167L5.04576 19.9247H5.04716Z"
      fill="#FFC200"
    />
  </svg>
);
